import { VacuumOutlineIcon } from './VacuumOutlineIcon';

/**
 * author: Google
 * id DE1B37E2-0CDF-4998-8E91-8A84F3D084BC
 * name vacuum-outline
 * version: 6.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/vacuum-outline.svg
 * tags
 * - Home Automation 
 */
export const VacuumCleanerOutlineIcon = VacuumOutlineIcon;
export default VacuumCleanerOutlineIcon